export const itemNameValidation = { regexp: /^[а-яА-Яa-zA-Z0-9\s_.\-—–:[\]()]+$/ }
export const itemSurnameValidation = { regexp: /^[а-яА-Яa-zA-Z0-9_.\-—–:[\]()]+$/ }
